import { render } from "./EditedOrderPage.vue?vue&type=template&id=30731e59"
import script from "./EditedOrderPage.vue?vue&type=script&lang=js"
export * from "./EditedOrderPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__